<div class="no-reservation-card">
  <h2>開啟您的健檢計畫</h2>
  <!-- 卡片區域 -->
  <div class="selection-right">
      <!-- 企業預約卡片 -->
      <div class="selection-card enterprise">
          <div class="selection-card-content enterprise-content">
              <div class="selection-card-title">
                <img src="assets/img/member-building.svg" alt="企業健檢" width="32" height="32"/>
                <app-text size="special2" weight="xl" color="gray-900">企業提供給</app-text>
                <app-text size="special2" weight="xl" color="primary-600">員工．眷屬</app-text>
              </div>
              <div>
                <p>結合智能分析與醫學建議，推薦具健康意義的加選項目，您可決定是否添加，讓健檢更符合個人需求。</p>
              </div>
              <div class="selection-card-buttons">
                <input 
                  type="text" 
                  class="selection-card-input"
                  [class.input-error]="hasError"
                  [formControl]="enterpriseCodeControl"
                  appCompanyCodeOnly
                  placeholder="請輸入企業代碼"
                  (keydown.enter)="handleEnterpriseClick()"
                  maxlength="10"
                  (input)="onInputChange($event)"
                />
                <button mat-button  [disabled]="isButtonDisabled" class="btn-fill-primary btn-size-m" (click)="handleEnterpriseClick()">
                  {{ 'new-home-page.company-card-button' | translate }}
                </button>
              </div>
          </div>
      </div>

      <!-- 個人預約卡片 -->
      <div class="selection-card personal">
        <div class="selection-card-box">
          <button mat-button class="selection-card-content-item" (click)="handlePersonalClick()">
            <div class="personal-content">
              <div class="selection-card-title">
                <img src="assets/img/member-search-orange.svg" alt="個人健檢" width="32" height="32" />
                <app-text size="special2" weight="xl" color="gray-900">個人預約</app-text> 
              </div>
              <div>
                <p>結合智能分析與醫學建議，推薦具健康意義的加選項目，您可決定是否添加，讓健檢更符合個人需求。</p>
              </div>
              
              <div class="home-card-btn-personal">
                <img width="24" height="24" ngSrc="/assets/img/i-arrow-secondary.svg" alt="" />
              </div>
            </div>
          </button>
        </div>
      </div>
  </div>
  <!-- 上次健檢日期 -->
   @if(lastCheckupDate()){
    <div class="last-checkup-date">
    <app-text size="m" weight="m">
      您的上次健檢紀錄：{{ lastCheckupDate() | formatDatePipe2 }}
    </app-text>
    <app-tag
            size="md"
            color="outline-green"
            [clickable]="true"
            (clicked)="goToHealthCheckHistory()">
            <app-text size="m" weight="m" color="primary-500"> 查看健檢報告 </app-text>
          </app-tag>
  </div>
   }
  
</div>
